import { useFlag as useUnleashFlag } from '@unleash/proxy-client-react';

export const APP_PREFIX = 'portal.';
export const GLOBAL_PREFIX = 'global.';

export const StoreDiscountState = {
  Open: 'open',
  Close: 'close',
  ComingSoon: 'coming_soon',
} as const;
export type StoreDiscountState = (typeof StoreDiscountState)[keyof typeof StoreDiscountState];

const useFlag = (name: string): boolean =>
  useUnleashFlag(name.startsWith(GLOBAL_PREFIX) ? name : APP_PREFIX + name);

export default useFlag;
